<div *transloco="let t">
    <mat-expansion-panel [expanded]="true">
        <mat-list dense class="site-list">
            <mat-panel-title class="mat-expansion-title" *ngIf="showTitle">
                <span>{{ t("provider.preferred-locations") }}</span>
            </mat-panel-title>
            <mat-list-item *ngFor="let site of sites">
                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-checkbox
                        color="primary"
                        [value]="site.siteId.toString()"
                        [checked]="selectedSiteIds.includes(site.siteId)"
                        (change)="selectSite($event)"
                        [name]="site.streetAddress"
                    >
                        <span>
                            {{ site.streetAddress }}<br />
                            {{ site.city }}, {{ site.stateCode }}
                            {{ site.postalCode }}&nbsp;
                        </span>
                    </mat-checkbox>
                </div>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>
</div>
